<template>
  <table class="table table-dark table-striped table-responsive-sm">
    <thead class="thead-dark">
      <tr>
        <th scope="col">#</th>
        <th scope="col">name</th>
        <th scope="col">email</th>
        <th scope="col">subject</th>
        <th scope="col">message</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(contact, key) in contacts" :key="key">
        <th scope="row">1</th>
        <td>{{ contact.name }}</td>
        <td>{{ contact.email }}</td>
        <td>{{ contact.subject }}</td>
        <td>{{ contact.message }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { db } from "../../store/firebase";
// const documnetPath = 'clientapp/forms';
export default {
  data() {
    return {
      contacts: [],
      isActive: true,
    };
  },
  created() {
    db.collection("contact")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // console.log(doc.id, ' => ', doc.data());
          this.contacts.push(doc.data());
        });
      });
  },
};
</script>

<style lang="scss">
</style>